module.exports = __webpack_public_path__ + "static/gallery_treehouse_3_thumb-bfb66ac5cd475934ea302fcf8c4aac5c.jpg";